import React, { useState, useReducer, useRef, useEffect, useImperativeHandle, forwardRef } from "react";
import CustomDropDown from "../../CustomDropDown/CustomDropDown";
import classes from './ChangeGroup.module.css';
import DataManager from "../../../hooks/DataManager";

// Reducer function
const dropDownReducer = (state, action) => {

    if (action.type === 'TOGGLE_DROPDOWN') {
        return { ...state, showDropDownOptions: !state.showDropDownOptions, isValid: null };
    }

    if (action.type === 'SELECT_OPTION') {
        return { ...state, selectedOption: action.payload, showDropDownOptions: false, isValid: action.val != "DropDown" };
    }

    if (action.type === 'BLUR_DROPDOWN') {
        return { ...state, showDropDownOptions: false, isValid: action.val != "DropDown" };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { selectedOption: null, isValid: null };
    }
    //otherwise 
    return { state };
};

const ChangeGroup = ({ apiData, DeviceUUID, companyName, NotificationTitle, label, dropDownOptions, setName, HandleCloseModal, update, setUpdate, siteDevices, setSiteDevices }) => {

    const dataManager = new DataManager();

    // dataManager.setItem('setPortalGroup', "")
    // dataManager.setItem('changePortalGroupForReset', "")

    const [formIsValid, setFormIsValid] = useState(false);



    // DropDown Drop Down reducer  ----------------
    const [dropDownState, dispatchDropDown] = useReducer(dropDownReducer, {
        showDropDownOptions: false,
        selectedOption: '', // Initial selectedOption state
        isValid: null
    });

    const { showDropDownOptions: showDropDownDropDownOptions, selectedOption: selectedDropDownOption } = dropDownState;

    const dropDownDropdownRef = useRef();

    const { isValid: dropDownIsValid } = dropDownState;

    useEffect(() => {
        const identifier = setTimeout(() => {
            // console.log('Checking form validity!');
            setFormIsValid(dropDownIsValid)
        }, 500);

        return () => {
            // console.log('CLEANUP');
            clearTimeout(identifier);
        };
    }, [dropDownIsValid]);

    // Drop down handlers ---------------

    const handleDropDownDropDownOnClick = () => {
        dispatchDropDown({ type: 'TOGGLE_DROPDOWN' });
    };

    const handleDropDownOptionChange = (option) => {
        dispatchDropDown({ type: 'SELECT_OPTION', payload: option });
        console.log(option)
        dataManager.setItem('setPortalGroup', option)
        dataManager.setItem('changePortalGroupForReset', option)

    };
    const handleDropDownBlur = () => {
        dispatchDropDown({ type: 'BLUR_DROPDOWN' });
    };

    const onClearHandler = () => {
        dispatchDropDown({ type: 'INPUT_CLEAR', val: "" })
    }

    return (
        <form className={classes["container"]} method="dialog" >
            <ul className={classes["inputs-list"]}>
                <div className={classes.label}>{label}</div>
                <li className={classes["input-container"]}>
                    <CustomDropDown
                        placeholder={companyName}
                        options={dropDownOptions}
                        selectedOption={selectedDropDownOption}
                        handleOptionChange={handleDropDownOptionChange}
                        handleBlur={handleDropDownBlur}
                        handleDropDownOnClick={handleDropDownDropDownOnClick}
                        showDropDownOptions={showDropDownDropDownOptions}
                        isValid={dropDownIsValid}
                        ref={dropDownDropdownRef}
                    />
                </li>
            </ul>

        </form>
    )


}

export default ChangeGroup;

